var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"thetext"},[_c('h2',{class:{glitch : _vm.loading},style:({color: _vm.getActiveDecade.colorscheme.title}),attrs:{"data-text":_vm.thetext}},[_vm._v(_vm._s(_vm.thetext))])])}
var staticRenderFns = []

export { render, staticRenderFns }